import { render, staticRenderFns } from "./LightUserDefinitionDialog.vue?vue&type=template&id=5b16bfb2&scoped=true&"
import script from "./LightUserDefinitionDialog.vue?vue&type=script&lang=ts&"
export * from "./LightUserDefinitionDialog.vue?vue&type=script&lang=ts&"
import style0 from "./LightUserDefinitionDialog.vue?vue&type=style&index=0&id=5b16bfb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b16bfb2",
  null
  
)

export default component.exports